export const uploadToImgbb = async (file) => {
  const apiKey = process.env.REACT_APP_IMGBB_API_KEY;
  if (!apiKey) throw new Error('REACT_APP_IMGBB_API_KEY が設定されていません');
  const base64 = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
  const formData = new FormData();
  formData.append('image', base64);
  const res = await fetch(`https://api.imgbb.com/1/upload?key=${apiKey}`, {
    method: 'POST',
    body: formData,
  });
  if (!res.ok) throw new Error('アップロードに失敗しました');
  const data = await res.json();
  if (!data.success) throw new Error(data.error?.message || 'アップロードに失敗しました');
  return data.data.url;
};
